import { useState } from "react"

export const useRegister = () => {
  const [isRegisterEnable, setRegisterEnable] = useState(false)

  const handleDisableRegister = () => {
    setRegisterEnable(false)
  }

  const handleEnableRegister = () => {
    setRegisterEnable(true)
  }

  return {
    isRegisterEnable,
    handleEnableRegister,
    handleDisableRegister,
  }
}
